<template>
  <div>
    <b-container fluid class="services">
      <div class="service-data" v-for="item in data" :key="item.id">
        <b-row style="margin-bottom: 30px;">
          <b-col cols="12" sm="3">
            <img :src="item.imageURL" alt="item.title" width="150" />
          </b-col>
          <b-col cols="12" sm="9">
            <h2 class="section-title text-uppercase">
              {{ item.title }}
              <span></span>
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <div v-html="item.description"></div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import { db } from "../firebase/db";
export default {
  data() {
    return {
      drawer: true,
      buttonName: "Know More",
      data: [],
      url: this.$route.params.id
    };
  },
  methods: {
    // Get data
    getData() {
      db.collection("news")
        .where("slug", "==", this.url)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.data.push(doc.data());
            this.fetching = false;
          });
        });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.service-data {
  background: #fff;
  // padding: 20px 120px;
  // margin: 40px 0;
}
.cntnt {
  padding: 48px 80px 2px 80px;
}
.mv {
  margin: 80px 0;
}
.team {
  margin: 80px 0;
}

.team-grid {
  text-align: center;
}
.col-xs-4 {
  width: 33.33333333%;
  float: left;
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}
/*-- Team --*/

.team {
  background: #f5f5f5;
  padding: 1em 0;
}

.team-grid {
  text-align: center;
}

.team-grid h4 {
  // font-family: "Red Rose", cursive;
  font-size: 30px;
  color: #363636;
  font-weight: 600;
  margin: 40px 0 20px;
}

.team-grid p {
  color: #636363;
  font-size: 20px;
  margin-top: -20px;
}

.model-3d-0 a {
  background: #5c5b5b;
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  -ms-transform-style: preserve-3d;
  -o-transform-style: preserve-3d;
  transform-style: preserve-3d;
}

.model-3d-0 .front,
.model-3d-0 .back {
  width: 30px;
  height: 30px;
  font-size: 1em;
  color: #fff;
  background: #faad81;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-transform: translateZ(18px);
  -moz-transform: translateZ(18px);
  -ms-transform: translateZ(18px);
  -o-transform: translateZ(18px);
  transform: translateZ(18px);
  -webkit-backface-visibility: visible;
  -moz-backface-visibility: visible;
  -ms-backface-visibility: visible;
  -o-backface-visibility: visible;
  backface-visibility: visible;
}

.model-3d-0 .back {
  font-size: 1em;
  color: #fff;
  -webkit-transform: rotateX(90deg) translateZ(18px);
  -moz-transform: rotateX(90deg) translateZ(18px);
  -ms-transform: rotateX(90deg) translateZ(18px);
  -o-transform: rotateX(90deg) translateZ(18px);
  transform: rotateX(90deg) translateZ(18px);
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  -o-backface-visibility: hidden;
  backface-visibility: hidden;
}

.model-3d-0 a:hover {
  -webkit-transform: rotateX(-90deg);
  -moz-transform: rotateX(-90deg);
  -ms-transform: rotateX(-90deg);
  -o-transform: rotateX(-90deg);
  transform: rotateX(-90deg);
}

.model-3d-0 a:hover .back {
  -webkit-backface-visibility: visible;
  -moz-backface-visibility: visible;
  -ms-backface-visibility: visible;
  -o-backface-visibility: visible;
  backface-visibility: visible;
}

.stack img {
  width: auto;
  height: 520px;
  vertical-align: bottom;
  border: 10px solid #fff;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -o-border-radius: 3px;
  -ms-border-radius: 3px;
  -moz-border-radius: 3px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -o-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -ms-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
}

.stack:last-of-type {
  margin-right: 0;
}

/* Third stack example (One stack element rotated in the opposite direction) */

.stack.twisted:before {
  -webkit-transform: rotate(4deg);
  -moz-transform: rotate(4deg);
  transform: rotate(4deg);
  -moz-transform: rotate(4deg);
  -o-transform: rotate(4deg);
}

.stack.twisted:after {
  -webkit-transform: rotate(-4deg);
  -moz-transform: rotate(-4deg);
  transform: rotate(-4deg);
  -ms-transform: rotate(-4deg);
  -o-transform: rotate(-4deg);
}

/* Reset all rotations on hover */

.stack:hover:before,
.stack:hover:after,
.team-grid:hover .stack:before,
.team-grid:hover .stack:after {
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  transform: rotate(0deg);
  -o-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
}

/* Stacks creted by the use of generated content */

.stack:before,
.stack:after {
  content: "";
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -o-border-radius: 3px;
  -ms-border-radius: 3px;
  -moz-border-radius: 3px;
  width: 100%;
  height: 100%;
  position: absolute;
  border: 10px solid #fff;
  left: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -ms-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -o-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -webkit-transition: 0.3s all ease-out;
  -moz-transition: 0.3s all ease-out;
  transition: 0.3s all ease-out;
  -o-transition: 0.3s all ease-out;
  -ms-transition: 0.3s all ease-out;
}

.stack:before {
  top: 4px;
  z-index: -10;
}

/* 1st element in stack (behind image) */

.stack:after {
  top: 8px;
  z-index: -20;
}

/* 2nd element in stack (behind image) */

.stack {
  float: none;
  width: 92%;
  margin: 3% 0% 8% 4%;
  position: relative;
  z-index: 1;
}

.card {
  background-color: #fff;
  border-radius: 2px;
  box-shadow: -1px 2px 4px rgba(0, 0, 0, 0.25), 1px 1px 3px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  max-width: 340px;
}

.card-media {
  width: 100%;
}

.card-details {
  padding: 5px 15px;
}

.card-head {
  font-weight: 400;
}

.card-head {
  font-size: 26px;
  margin-bottom: 15px;
}

.card-action-button {
  border-radius: 2px;
  color: #ffab40;
  cursor: pointer;
  display: inline-block;
  font-weight: 500;
  margin: 0;
  padding: 10px;
  text-decoration: none;
}

.card-action-button:hover {
  background-color: rgba(255, 168, 58, 0.2);
}
.icmspic {
  padding: 120px 0 0 0;
  height: 100%;
}
.icmsinfo {
  padding: 40px 40px 0 40px;
  // width: 95%;
}
.icmsinfo .midtext {
  font-family: "Red Rose", cursive;
  font-size: 30px;
  color: #323232;
  line-height: 42px;
  margin: 0 0 12px 0;
}
.icmsinfo .bigtext {
  font-family: "Red Rose", cursive;
  font-size: 40px;
  color: #af0000;
  line-height: 50px;
  margin: 0 0 20px 0;
}
.icmsinfo .smalltext {
  font-size: 20px;
  line-height: 24px;
  color: #323232;
  width: 95%;
}
.companyglance {
  margin: 50px 0 0 0;
}
.compglancetxt {
  font-size: 30px;
  color: #323232;
  font-family: "Red Rose", cursive;
}
.glancegroup {
  margin: 30px 0 0 0;
}
.glanceitem {
  display: inline-block;
  vertical-align: top;
  margin: 0 42px 0 0;
  padding: 0 42px 0 0;
  border-right: 1px solid #b0bec5;
}
.glancenumber {
  color: #af0000;
  font-size: 48px;
  font-family: "Red Rose", cursive;
}
.glancetxt {
  font-size: 14px;
  font-family: "Red Rose", cursive;
  text-transform: uppercase;
  color: #263238;
}
.glanceitem:last-child {
  border-right: 0;
  padding: 0;
  margin: 0;
}
</style>
